import { SERVER_URL, getHeaders, handleResponse } from '../apiConfig';

const ATTENDANCE_BASE_URL = `${SERVER_URL}/api/attendance`;

export const fetchAttendanceReasons = async () => {
  const response = await fetch(`${ATTENDANCE_BASE_URL}/reasons`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const addAttendanceReason = async (reason_text) => {
  const response = await fetch(`${ATTENDANCE_BASE_URL}/reasons`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ reason_text })
  });
  return handleResponse(response);
};

export const deleteAttendanceReason = async (reasonId) => {
  const response = await fetch(`${ATTENDANCE_BASE_URL}/reasons/${reasonId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchClusterAttendance = async (clusterId, standardId, date, academicYearId) => {
  let url = `${ATTENDANCE_BASE_URL}/cluster/${clusterId}?standardId=${standardId}&date=${date}`;
  if (academicYearId) url += `&academicYearId=${academicYearId}`;
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const saveClusterAttendance = async (clusterId, data) => {
  const response = await fetch(`${ATTENDANCE_BASE_URL}/cluster/${clusterId}`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const exportClusterAttendanceCSV = async (clusterId, standardId, month, academicYearId, startDate, endDate) => {
  let url = `${ATTENDANCE_BASE_URL}/export?clusterId=${clusterId}`;
  if (month) url += `&month=${month}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (standardId !== null && standardId !== undefined && standardId !== 'null' && standardId !== 'undefined') {
    url += `&standardId=${standardId}`;
  }
  if (academicYearId) url += `&academicYearId=${academicYearId}`;
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const deleteClusterAttendance = async (clusterId, standardId, date) => {
  const response = await fetch(`${ATTENDANCE_BASE_URL}/cluster/${clusterId}?standardId=${standardId}&date=${date}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};


